<template>
  <div class="animated fadeIn row">
    <div class="col-sm-12">
      <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> {{$t('MODULES')}}
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3">
                <b-form-fieldset v-bind:label="$t('SEARCH')">
                  <b-form-input v-model="pagination.query"></b-form-input>
                </b-form-fieldset>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
            <p class="center">{{$t('NODATAFOUND')}}</p>
          </div>
          <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
            <table class="table table-responsive-sm table-striped">
              <thead>
                <tr>
                  <th>{{$t('ID')}}</th>
                  <th>{{$t('MODULENAME')}}</th>
                  <th>{{$t('SAVE')}}</th>
                  <th>{{$t('ACTIONS')}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in data.root">
                  <tr :key="item.moduleId">
                    <td>{{item.moduleId}}</td>
                    <td>{{item.moduleName}}</td>
                    <td>
                        <b-button type="reset" size="sm" variant="primary" v-on:click.prevent="showItem(item)"><icon name="edit"></icon> {{$t('EDIT')}}</b-button>
                    </td>
                    <td>
                        <router-link class="btn btn-sm btn-primary" :to="'/modules/keypadcodes/'+item.moduleId" v-if="item.moduleVersion == 3"><icon name="rocket"></icon> {{$t('KEYPADCODES')}}</router-link>
                        <b-button v-if="globals.groupId != 4" type="reset" size="sm" variant="secondary" v-on:click.prevent="assignUsers(item)"><icon name="user"></icon> {{$t('ASSIGNTOUSERS')}}</b-button>
                        <b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.moduleId)"><icon name="ban"></icon> {{$t('DELETE')}}</b-button>
                    </td>
                  </tr>
                  <tr :key="item.moduleId" v-if="item.shown">
                    <td colspan="4">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('MODULENAME')">
                                <inputvalidation :formerror="formError" name="moduleName"><b-form-input type="text" v-model="item.moduleName" v-bind:placeholder="$t('Modules')"></b-form-input></inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('DEFAULTVALUE')">
                                <inputvalidation :formerror="formError" name="defaultValue">
                                  <select class="form-control" name="defaultValue" v-model="item.defaultValue">
                                    <option value="0">{{$t('OFF')}}</option>
                                    <option value="1">{{$t('ON')}}</option>
                                  </select>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('MODULEMAC')">
                                <inputvalidation :formerror="formError" name="moduleMac"><b-form-input type="text" v-model="item.moduleMac" v-bind:placeholder="$t('MODULEMAC')"></b-form-input></inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('MODULEVERSION')">
                                <inputvalidation :formerror="formError" name="moduleVersion">
                                  <select class="form-control" name="moduleVersion" v-model="item.moduleVersion">
                                    <option value="1">{{$t('WIAUTOMATEMODULE')}}</option>
                                    <option value="2">{{$t('SWITCHSENSOR')}}</option>
                                    <option value="3">{{$t('KEYPAD')}}</option>
                                    <option value="4">{{$t('SHELLYRELAY')}}</option>
                                    <option value="5">{{$t('SHELLY1L')}}</option>
                                    <option value="6">{{$t('THERMOSTAT')}}</option>
                                    <option value="7">{{$t('SHELLYMOTION')}}</option>
                                    <option value="8">{{$t('DOORWINDOWSENSOR')}}</option>
                                    <option value="9">{{$t('SHELLYI3')}}</option>
                                    <option value="10">{{$t('SHELLY25')}}</option>
                                    <option value="11">{{$t('WATERINGCONTROLER')}}</option>
                                    <option value="12">{{$t('SMOKEDETECTOR')}}</option>
                                    <option value="13">{{$t('NSPANEL')}}</option>
                                    <option value="14">{{$t('REOLINKDOORBELL')}}</option>
                                    <option value="15">{{$t('SHELLY2PM')}}</option>
                                    <option value="16">{{$t('SHELLYDIMMER')}}</option>
                                    <option value="17">{{$t('SHELLYRGBW2')}}</option>
                                    <option value="18">{{$t('SHELLYMINI')}}</option>
                                    <option value="19">{{$t('MODBUS')}}</option>
                                    <option value="20">{{$t('WEATHERSTATION')}}</option>
                                    <option value="21">{{$t('SHUTTERS')}}</option>
                                    <option value="22">{{$t('TEMPHUMIDITYSENSOR')}}</option>
                                    <option value="23">{{$t('AIRCONDITIONING')}}</option>
                                    <option value="24">{{$t('PULSECOVER')}}</option>
                                    <option value="25">{{$t('PULSEBUTTON')}}</option>
                                  </select>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset>
                                <inputvalidation :formerror="formError" name="hidden">
                                  <b-form-checkbox v-model="item.hidden" value="1" unchecked-value="0">{{$t('HIDDEN')}}</b-form-checkbox>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row" v-if="item.moduleVersion == 1">
                            <div class="col-sm-12">
                              <b-form-fieldset>
                                <inputvalidation :formerror="formError" name="mainTemp">
                                  <b-form-checkbox v-model="item.mainTemp" value="1" unchecked-value="0">{{$t('MAINTEMP')}}</b-form-checkbox>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset>
                                <inputvalidation :formerror="formError" name="doNotNotify">
                                  <b-form-checkbox v-model="item.doNotNotify" value="1" unchecked-value="0">{{$t('DONOTNOTIFY')}}</b-form-checkbox>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset>
                                <inputvalidation :formerror="formError" name="alarmOnSensorChange">
                                  <b-form-checkbox v-model="item.alarmOnSensorChange" value="1" unchecked-value="0">{{$t('ALARMONSENSORCHANGE')}}</b-form-checkbox>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="row" v-if="item.moduleVersion == 1">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('MODULETYPE')">
                                <inputvalidation :formerror="formError" name="moduleType">
                                  <select class="form-control" name="moduleType" v-model="item.moduleType">
                                    <option value="0">{{$t('MOMENTARYWITHSENSOR')}}</option>
                                    <option value="1">{{$t('MOMENTARYWITHLOG')}}</option>
                                    <option value="2">{{$t('MOMENTARY')}}</option>
                                    <option value="3">{{$t('TOGGLEWITHSENSOR')}}</option>
                                    <option value="4">{{$t('TOGGLE')}}</option>
                                    <option value="5">{{$t('TOGGLEBYSENSOR')}}</option>
                                  </select>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row" v-if="item.moduleVersion == 1">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('SWITCHTIMEOUT')">
                                <inputvalidation :formerror="formError" name="switchTimeout"><b-form-input type="text" v-model="item.switchTimeout" v-bind:placeholder="$t('SWITCHTIMEOUT')"></b-form-input></inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row" v-if="item.moduleVersion == 1">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('RELAYTIMEOUT')">
                                <inputvalidation :formerror="formError" name="relayTimeout"><b-form-input type="text" v-model="item.relayTimeout" v-bind:placeholder="$t('RELAYTIMEOUT')"></b-form-input></inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('BUILDING')">
                                <inputvalidation :formerror="formError" name="buildingId">
                                  <select class="form-control" name="buildingId" v-model="item.buildingId">
                                    <option :value="null">{{$t('UNCLAIMED')}}</option>
                                    <option v-for="one in buildings" :key="one.buildingId" :value="one.buildingId">{{one.name}}</option>
                                  </select>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row" v-if="item.moduleVersion == 24 || item.moduleVersion == 25">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('RELAYINDEX')">
                                <inputvalidation :formerror="formError" name="relayIndex">
                                  <b-form-input type="number" min="1" max="4" v-model.number="item.relayIndex"></b-form-input>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('MODULECATEGORY')">
                                <inputvalidation :formerror="formError" name="moduleCategoryId">
                                  <select class="form-control" name="moduleCategoryId" v-model="item.moduleCategoryId">
                                    <option :value="null">{{$t('UNCATEGORISED')}}</option>
                                    <option v-for="one in moduleCategories" :key="one.moduleCategoryId" :value="one.moduleCategoryId">{{one.name}}</option>
                                  </select>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('MDIICON')">
                                <inputvalidation :formerror="formError" name="mdiIcon">
                                  <icon-picker v-model="item.mdiIcon"></icon-picker>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('ORDERNUM')">
                                <inputvalidation :formerror="formError" name="orderNum"><b-form-input type="text" v-model="item.orderNum" v-bind:placeholder="$t('ORDERNUM')"></b-form-input></inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="row" v-if="item.moduleVersion == 1">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('DIGITALDEVICE')">
                                <inputvalidation :formerror="formError" name="digitalDevice">
                                  <select class="form-control" name="digitalDevice" v-model="item.digitalDevice">
                                    <option value="0">{{$t('NONE')}}</option>
                                    <option value="1">{{$t('DIGITALTEMEPRATURESENSOR')}}</option>
                                    <option value="2">{{$t('ADDITIONALRELAYDEPENDANT')}}</option>
                                    <option value="3">{{$t('ADDITIONALRELAYINDEPENDANT')}}</option>
                                  </select>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row" v-if="item.moduleVersion == 1 && item.digitalDevice == 2">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('SECRELAYTIMEOUT')">
                                <inputvalidation :formerror="formError" name="secRelayTimeout"><b-form-input type="text" v-model="item.secRelayTimeout" v-bind:placeholder="$t('SECRELAYTIMEOUT')"></b-form-input></inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row" v-if="item.moduleVersion == 1">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('ANALOGDEVICE')">
                                <inputvalidation :formerror="formError" name="analogDevice">
                                  <select class="form-control" name="analogDevice" v-model="item.analogDevice">
                                    <option value="0">{{$t('NONE')}}</option>
                                    <option value="1">{{$t('ANALOGDBSENSOR')}}</option>
                                    <option value="2">{{$t('ANALOGPRESSURESENSOR')}}</option>
                                    <option value="3">{{$t('ANALOGDISTANCESENSOR')}}</option>
                                  </select>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-fieldset v-bind:label="$t('COMPANYID')">
                                <inputvalidation :formerror="formError" name="companyId">
                                  <select class="form-control" name="companyId" v-model="item.companyId">
                                    <option v-bind:value="company.companyId" v-bind:key="company.companyId" v-for="company in companies.root">{{company.companyName}}</option>
                                  </select>
                                </inputvalidation>
                              </b-form-fieldset>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-12">
                          <div slot="footer">
                            <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
                            <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow(item)"><icon name="dot-circle-o"></icon> {{$t('SUBMIT')}}</b-button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <nav>
              <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
            </nav>
          </div>
        </div>
      </div>
      <b-modal centered size="lg" ref="assignusers" id="assignusers" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveModuleUsers" v-bind:title="$t('ASSIGNTOUSERS')">
        <form method="get" action="">
          <div class="row">
            <div class="col-12">
              <b-form-fieldset v-bind:label="$t('MODULES')">
                <inputvalidation :formerror="formError" name="modulesSelected">
                  <b-form-select multiple :select-size="10" value-field="userId" text-field="username" v-model="selecteditem.moduleUsers" :options="users.root" class="mb-3"></b-form-select>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <p class="bg-danger" v-if="saveModuleUsersError.error && typeof saveModuleUsersError.notice == 'string'">{{saveModuleUsersError.notice}}</p>
          <div class="clearfix"></div>
        </form>
      </b-modal>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import Api from '@/api/Modules';
import CompanyApi from '@/api/admin/UserCompanies';
import UsersApi from '@/api/admin/Users';

import BuildingsApi from '@/api/Buildings';
import ModuleCategoriesApi from '@/api/ModuleCategories';
import IconPicker from '@/components/lib/IconPicker.vue';

export default {
    name: 'Modules',
    components:
  {
      'icon-picker': IconPicker,
  },
    data()
    {
        return {
            data: {},
            companies: {},
            users: {},
            buildings: [],
            moduleCategories: [],
            selecteditem: {},
            formError: {},
            saveModuleUsersError: {},
            formData: {
                id: '',
                moduleName: '',
                defaultValue: 0,
                deviceId: '',
                moduleType: 0,
                switchTimeout: 100,
                relayTimeout: 100,
                // the android app still renders from these two, and nothing in
                // the web offers a way to change them any more, so new modules
                // get a real file rather than a name with no svg behind it
                iconType: 'icon_107.svg',
                iconColor: '#000000',
                mdiIcon: null,
                hidden: 0,
                mainTemp: 0,
                doNotNotify: 0,
                alarmOnSensorChange: 0,
                orderNum: 0,
                digitalDevice: 0,
                companyId: 1,
            },
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 20,
                searchTimeout: false,
            },
            companypagination:
            {
                query: '',
                currentPage: 1,
                limit: 200,
                searchTimeout: false,
            },
            userspagination:
            {
                query: '',
                currentPage: 1,
                limit: 100,
                searchTimeout: false,
            },
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getCompanies();
        me.getUsers();
        me.getBuildings();
        me.getModuleCategories();
    },
    methods:
  {
      // the list the building picker offers, unclaimed is added in the template
      async getModuleCategories()
      {
          const me = this;

          try
          {
              const data = await ModuleCategoriesApi.selectRow({ start: 0, limit: 200 });

              if (data && !data.error)
              {
                  me.moduleCategories = data.root || [];
              }
          }
          catch (error)
          {
              me.$notify.notice({ error: true, notice: 'Error' });
          }
      },
      async getBuildings()
      {
          const me = this;

          try
          {
              const data = await BuildingsApi.selectRow({ start: 0, limit: 200 });

              if (data && !data.error)
              {
                  me.buildings = data.root || [];
              }
          }
          catch (error)
          {
              me.$notify.notice({ error: true, notice: 'Error' });
          }
      },
      saveModuleUsers(bvEvt)
      {
          const me = this;

          bvEvt.preventDefault();

          Api.saveModuleUsers(me.selecteditem, (val) =>
          {
              if (val.error)
              {
                  me.$notify.notice(val);
                  me.saveModuleUsersError = val;
              }
              else
              {
                  me.$notify.notice(val);
                  me.saveModuleUsersError = {};
                  me.getData();
                  me.$refs.assignusers.hide();
              }
          });
      },
      assignUsers(item)
      {
          const me = this;
          me.selecteditem = item;
          me.$refs.assignusers.show();
      },
      showItem(item)
      {
          const me = this;
          if (typeof item.shown === 'undefined')
          {
              me.$set(item, 'shown', true);
          }
          else
          {
              item.shown = !item.shown;
          }
      },
      getCompanies()
      {
          const me = this;
          CompanyApi.selectRow(me.getCompanyParams, (data) =>
          {
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }
              me.companies = data;
          });
      },
      getUsers()
      {
          const me = this;
          UsersApi.selectRow(me.getUsersParams, (data) =>
          {
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }
              me.users = data;
          });
      },
      saveRow(item)
      {
          const me = this;

          if (typeof item.moduleId !== 'undefined')
          {
              item.id = item.moduleId;
              delete (item.moduleId);
          }

          Api.save(item, (val) =>
          {
              if (val.error)
              {
                  me.$notify.notice(val);
                  me.formError = val;
              }
              else
              {
                  me.$notify.notice(val);
                  me.formError = {};
                  me.getData();
              }
          });
      },
      getData()
      {
          const me = this;
          Api.selectRow(me.getParams, (data) =>
          {
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }
              me.data = data;
          });
      },
      deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  btnAction()
                  {
                      Api.deleteRow({ id }, (data) =>
                      {
                          me.$notify.notice(data);
                          me.getData();
                      });
                  },
              });
      },
  },
    watch:
    {
        'pagination.currentPage'()
        {
            const me = this;
            me.getData();
        },
        'pagination.query'()
        {
            const me = this;

            if (me.pagination.searchTimeout !== false)
            {
                clearTimeout(me.pagination.searchTimeout);
            }

            me.pagination.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.pagination.searchTimeout = false;
            }, 300);
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getParams()
        {
            const me = this;
            const data = { ...me.pagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        getCompanyParams()
        {
            const me = this;
            const data = { ...me.companypagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        getUsersParams()
        {
            const me = this;
            const data = { ...me.userspagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
    },
};
</script>
